// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bannedMainDiv {
    margin-left: 200px;
}

.cursorPointer {
    cursor: pointer;
}

.marginTop25 {
    margin-top: 25px;
}

.marginLeft10 {
    margin-left: 10px;
}

.bannedImages {
    display: flex;
    flex-wrap: wrap;
}

.bannedImagesDiv {
    margin: 50px 0 0 20px;
    display: flex;
}

.notDeletedText{
    color: white
}

.deletedText {
    color: red;
    text-align: center;
    width: 150px;
    height: 20px;
}

.autoCuratedProfilesBox {
    margin: 50px 0 0 20px;
    display: flex;
    width: 800px;
}

.bannedImageStyles {
    width: 150px;
    height: 150px;
    border-radius: 20px;
    margin-right: 20px;
}

.nextInctiveStyle {
    cursor: pointer;
    margin-left: 30px;
}
.actionButtonBannedDiv {
    margin-top: 75px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Banned.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".bannedMainDiv {\n    margin-left: 200px;\n}\n\n.cursorPointer {\n    cursor: pointer;\n}\n\n.marginTop25 {\n    margin-top: 25px;\n}\n\n.marginLeft10 {\n    margin-left: 10px;\n}\n\n.bannedImages {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.bannedImagesDiv {\n    margin: 50px 0 0 20px;\n    display: flex;\n}\n\n.notDeletedText{\n    color: white\n}\n\n.deletedText {\n    color: red;\n    text-align: center;\n    width: 150px;\n    height: 20px;\n}\n\n.autoCuratedProfilesBox {\n    margin: 50px 0 0 20px;\n    display: flex;\n    width: 800px;\n}\n\n.bannedImageStyles {\n    width: 150px;\n    height: 150px;\n    border-radius: 20px;\n    margin-right: 20px;\n}\n\n.nextInctiveStyle {\n    cursor: pointer;\n    margin-left: 30px;\n}\n.actionButtonBannedDiv {\n    margin-top: 75px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
